import React from 'react';
import PropTypes from 'prop-types';
import style from '../Debug.module.scss';

const UserPanel = (props = {}) => {
  const { handleUserData, segmentDeviceId, userData } = props;
  const { deviceId } = userData;
  return (
    <div className={style.panel}>
      <div className={style.header}>Device ID</div>
      <div className={style.formLabel}>Original: {segmentDeviceId}</div>
      <div className={style.formLabel}>Override: {deviceId}</div>
      <div className={style.body}>
        <form onSubmit={handleUserData}>
          <div>
            <input type="text" defaultValue={deviceId} name="deviceId" id="deviceId" />
            <button type="submit">Set Param</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UserPanel;

UserPanel.defaultProps = {
  handleUserData: () => {},
  segmentDeviceId: null,
  userData: {},
};

UserPanel.propTypes = {
  handleUserData: PropTypes.func,
  segmentDeviceId: PropTypes.string,
  userData: PropTypes.shape({}),
};
